<template>
    <div>
        <a-row :gutter="48">
            <a-col :span="24">
                <a-form-item label="状态">
                    <a-row>
                        <a-col :span="12"><a-switch checked-children="开启" un-checked-children="关闭" :checkedValue="1"
                                :unCheckedValue="2" v-model:checked="state.status"
                                @change="inputChange"></a-switch></a-col>
                        <a-col :span="12"><a-button type="primary" @click="Get_Server_Kuaidi_Config">填入服务商{{ props.type
                            == 1 ? '京东' :
                                '顺丰' }}配置信息</a-button></a-col>
                    </a-row>
                </a-form-item>
            </a-col>
            <template v-if="state.status == 1">
                <a-col :span="24">
                    <a-form-item label="应用账号">
                        <a-input placeholder="请输入" v-model:value="state.appKey"
                            @change="inputChange"></a-input>京东的appKey，顺丰的partnerID
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="应用密码">
                        <a-input placeholder="请输入" v-model:value="state.appSecret"
                            @change="inputChange"></a-input>京东的appSecret，顺丰的checkword
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="月结卡号">
                        <a-input placeholder="请输入" v-model:value="state.customerCode" @change="inputChange"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="access_token">
                        <a-input placeholder="请输入" v-model:value="state.access_token" @change="inputChange"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="refresh_token">
                        <a-input placeholder="请输入" v-model:value="state.refresh_token" @change="inputChange"></a-input>
                    </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="市内邮费">
                        <a-input placeholder="请输入金额" v-model:value="state.city_price" style="width: 150px"
                            @change="inputChange" addonAfter="元"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="省内邮费">
                        <a-input placeholder="请输入金额" v-model:value="state.province_price" style="width: 150px"
                            @change="inputChange" addonAfter="元"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="省外邮费">
                        <a-input placeholder="请输入金额" v-model:value="state.other_price" style="width: 150px"
                            @change="inputChange" addonAfter="元"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="特殊省份">
                        <a-select ref="select" v-model:value="state.special_id" style="width: 150px"
                            :options="state.options" show-search option-filter-prop="name" placeholder="请搜索选择"
                            :fieldNames="{ label: 'name' }" labelInValue
                            @change="handleSpecialChange"></a-select>(特殊省份自定义邮费)
                        <div>
                            <div v-for="(item, index) in state.special" :key="index" class="phone-item">
                                <a-row>
                                    <a-col :span="6">{{ item.name }}</a-col>
                                    <a-col :span="18"><a-input placeholder="请输入金额" v-model:value="item.price"
                                            style="width: 150px" @change="inputChange" addonAfter="元"></a-input>
                                        <DeleteOutlined style="cursor: pointer" @click="handleSpecialClose(item)" />
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="排除省份">
                        <a-select ref="select" v-model:value="state.exclude_id" style="width: 150px"
                            :options="state.options" show-search option-filter-prop="name" placeholder="请搜索选择"
                            :fieldNames="{ label: 'name' }" labelInValue
                            @change="handleExcludeChange"></a-select>(不支持邮寄的省份)
                        <div>
                            <a-tag v-for="(item, index) in state.exclude_province" :key="index" closable
                                @close="handleExcludeClose(item)">{{ item.name }}</a-tag>
                        </div>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="包邮减免">
                        <a-input placeholder="请输入金额" v-model:value="state.free_money" style="width: 150px"
                            @change="inputChange" addonAfter="元"></a-input>（超过此金额的需要补差价）
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="付款方式">
                        <a-radio-group v-model:value="state.pay_way" @change="inputChange" button-style="solid">
                            <a-radio :value="1">服务商余额支付</a-radio>
                            <a-radio :value="2">平台余额</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </template>
        </a-row>
    </div>
</template>
<script lang="ts" setup>
import { reactive, watch, onMounted } from 'vue';
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { DeleteOutlined } from '@ant-design/icons-vue'
const emit = defineEmits(['update:value'])
const props = defineProps({
    value: {
        type: Object,
        default: null,
    },
    type: {
        type: Number,
        default: null,
    },
})
interface stateType {
    status: number,
    appKey: string,
    appSecret: string,
    customerCode: string,
    access_token: string,
    refresh_token: string,
    city_price: number,
    province_price: number,
    other_price: number,
    special: Array<any>,
    exclude_province: Array<any>,
    free_money: number,
    options: Array<any>,
    exclude_id: number | null,
    special_id: number | null
    pay_way: number
}
const state = reactive<stateType>({
    status: 2,//状态 1启用 2禁用
    appKey: '',
    appSecret: '',
    customerCode: '',
    access_token: '',
    refresh_token: '',
    city_price: 100,//市内
    province_price: 100,//省内
    other_price: 100,//省外
    special: [],//特殊省
    exclude_province: [],//不支持省份
    free_money: 0,//包邮减免金额
    options: [],//省份的 选择
    exclude_id: null,//排除的省份id
    special_id: null,//特殊省份id
    pay_way: 1,//快递付款方式 1服务商余额支付 2平台余额

})
onMounted(() => {
    getByLevel()
})
watch(() => props.value, (val) => {
    if (val) {
        state.status = val.status || 2
        state.appKey = val.appKey || ''
        state.appSecret = val.appSecret || ''
        state.customerCode = val.customerCode || ''
        state.access_token = val.access_token || ''
        state.refresh_token = val.refresh_token || ''
        state.city_price = val.city_price || null
        state.province_price = val.province_price || null
        state.other_price = val.other_price || null
        state.special = val.special || []
        state.exclude_province = val.exclude_province || []
        state.free_money = val.free_money || 0
        state.pay_way = val.pay_way || 1
    }
}, {
    deep: true,
    immediate: true,
})
const inputChange = () => {
    const obj = {
        status: state.status,
        appKey: state.appKey,
        appSecret: state.appSecret,
        customerCode: state.customerCode,
        access_token: state.access_token,
        refresh_token: state.refresh_token,
        city_price: state.city_price,
        province_price: state.province_price,
        other_price: state.other_price,
        special: state.special,
        exclude_province: state.exclude_province,
        free_money: state.free_money,
        pay_way: state.pay_way
    }
    emit('update:value', obj)
}
// 根据级别获取数据
const getByLevel = async () => {
    let url = '/admin/area'
    let requestParam = {
        url: url,
        method: 'get'
    }
    let localData = localStorage.getItem('AddressProvinceList1')
    if (localData) {
        state.options = JSON.parse(localData)
        //把湖南放前面
        let list = JSON.parse(localData)
        let index = 0
        for (let a in list) {
            let aa = list[a]
            if (aa.name.includes('湖南')) {
                index = parseInt(a)
            }
        }
        list = [list[index], ...list.slice(0, index), ...list.slice(index + 1)]
        state.options = list
    } else {
        baseService(requestParam)
            .then((res) => {
                state.options = res.data.map((item) => {
                    item.isLeaf = false
                    return item
                })
                //先存入本地
                localStorage.setItem('AddressProvinceList1', JSON.stringify(state.options))
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('获取失败')
                }
            })
    }
}
//排除的省份
const handleExcludeChange = (value) => {
    let item = state.exclude_province.find((item) => {
        return item.id == value.key
    })
    if (!item) {
        state.exclude_province.push({
            id: value.value,
            name: value.label
        })
    }
    state.exclude_id = null
    inputChange()
}
const handleExcludeClose = (item) => {
    state.exclude_province = state.exclude_province.filter((item1) => {
        return item1.id != item.id
    })
    inputChange()
}
//特殊的省份
const handleSpecialChange = (value) => {
    let item = state.special.find((item) => {
        return item.id == value.key
    })
    if (!item) {
        state.special.push({
            id: value.value,
            name: value.label,
            price: state.other_price
        })
    }
    state.special_id = null
    inputChange()
}
const handleSpecialClose = (item) => {
    state.special = state.special.filter((item1) => {
        return item1.id != item.id
    })
    inputChange()
}
const Get_Server_Kuaidi_Config = () => {
    let url = '/admin/v1/fws_platform/getKuaidiConfig'
    let requestParam = {
        url: url,
        method: 'post',
        data: {
            type: props.type
        }
    }
    baseService(requestParam)
        .then((res) => {
            //把res.data数组中的键名对应的分配给state中的值
            state.status = res.data['status']
            state.appKey = res.data['appKey']
            state.appSecret = res.data['appSecret']
            state.customerCode = res.data['customerCode']
            state.access_token = res.data['access_token']
            state.refresh_token = res.data['refresh_token']
            state.city_price = res.data['city_price']
            state.province_price = res.data['province_price']
            state.other_price = res.data['other_price']
            state.special = res.data['special']
            state.exclude_province = res.data['exclude_province']
            state.free_money = res.data['free_money']
            state.pay_way = res.data['pay_way']
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取失败')
            }
        })
}
</script>
